import { useState, useEffect, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./category.css";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";

const categoryEditEndpoint = ApiEndpoints.category.categoryEdit;
const categoryUpdateEndPoint = ApiEndpoints.category.categoryUpdate;

export default function EditCategory() {
  const { category_id } = useParams();
  const [data, setData] = useState({ name: "" });
  const navigate = useNavigate();

  useEffect(() => {
    const dataFetch = async () => {
      try {
        const response = await ApiRequest(
          "GET",
          `${categoryEditEndpoint}${category_id}`
        );
        const result = response.blogcategory;
        setData(result);
      } catch (error) {
        console.log(error);
      }
    };
    dataFetch();
  }, [category_id]);

  const handleInputChange = useCallback(
    (e) => {
      const { name, value } = e.target;
      setData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    },[]);

  const handleSubmit = useCallback(
    async (event) => {
      event.preventDefault();
      const payload = {
        blogcategory_id: category_id,
        name: data.name,
      };
      console.log(payload);
      try {
        const response = await ApiRequest(
          "POST",
          categoryUpdateEndPoint,
          payload
        );
        console.log(response);
        navigate("/admin/category ");
      } catch (error) {
        console.log(error);
      }
    },[category_id, data.name, navigate]);

  return (
    <>
      <div className="header-add-category">
        <h5>Edit Category</h5>
      </div>
      <div className="add-category-content">
        <form onSubmit={handleSubmit}>
          <label>Name:</label>
          <input
            required
            name="name"
            value={data.name}
            type="text"
            className="form-control"
            onChange={handleInputChange}
          />
          {/* <input value={data.name} type="text" className="form-control" /> */}
          <div className="submit-formbtn">
            <button type="submit" className="default-btn">
              Save Changes
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
